import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { TEMPLATE_BASE64 } from '@/lib/templates-base64/DMVTSP';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { useVatTuSanPhamContext } from '../context';

interface ActionBarProps {
  onImportExcel?: () => void;
  onExportExcel?: () => void;
}

export function ActionBar({ onImportExcel, onExportExcel }: ActionBarProps) {
  const { selectedObj, handleAddClick, handleEditClick, handleDeleteClick, handleCopyClick, handleRefreshClick } =
    useVatTuSanPhamContext();

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(TEMPLATE_BASE64, 'Danh mục vật tư sản phẩm.xlsx');
  };

  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục vật tư, sản phẩm</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' variant='primary' onClick={handleAddClick} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={handleEditClick} disabled={!selectedObj} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xoá' onClick={handleDeleteClick} disabled={!selectedObj} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={handleCopyClick} disabled={!selectedObj} />
      <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={handleRefreshClick} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportExcel,
            group: 0
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcel,
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
}
